// extracted by mini-css-extract-plugin
export var arrow = "_30-6";
export var changeItem = "_30-3";
export var changesHeader = "_30-1";
export var changesList = "_30-2";
export var container = "_30-0";
export var pathLabel = "_30-4";
export var value = "_30-7";
export var valuesContainer = "_30-5";